import React, { Component } from 'react';
import './node.css';

class Node extends Component {
    render() {
        const { row, col, isFinish, isStart, isWall, onMouseDown, onMouseUp, onMouseEnter } = this.props;
        const extraClassName = isFinish ?
            'node-finish' : isStart ?
                'node-start' : isWall ?
                    'node-wall' : '';
        return (
            <td
                id={`node-${row}-${col}`}
                className={`node ${extraClassName}`}
                onMouseDown={() => onMouseDown(row, col)}
                onMouseEnter={() => onMouseEnter(row, col)}
                onMouseUp={() => onMouseUp()
                }>
            </td >
        );
    }
}

export default Node;